import { Component } from '@angular/core';

@Component({
  selector: 'app-rulebook',
  standalone: false,
  templateUrl: './rulebook.html',
  styleUrl: './rulebook.css'
})
export class Rulebook {

}
